export default __webpack_public_path__ + "static/media/1250.150a255d.png";